import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import FetchData from "../../providers/dataProvider";

const ViewCustomer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: designationdata } = FetchData("designation");
  const { data: documentList } = FetchData("distributorDocuments");
  const { data: salesEngineerData } = FetchData("userprofile");
  const { data: customertype } = FetchData("customertype");

  const [viewCustomer, setViewCustomer] = useState(null);
  const [salesEngineer, setSalesEngineer] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      const itemCopy = { ...item };
      if (itemCopy) {
        itemCopy?.customerContact?.map((obj) => {
          const designationObj = designationdata?.find(
            (el) => el?.id == obj?.designationId
          );
          if (designationObj)
            obj["designationName"] = designationObj?.designationName;
          else obj["designationName"] = "";

          return obj;
        });
        itemCopy?.customerDocument?.map((obj) => {
          const documentObj = documentList?.find(
            (el) => el?.id == obj?.attachmentId
          );
          if (documentObj) obj["documentName"] = documentObj?.documentName;
          else obj["documentName"] = "";

          return obj;
        });
      }
      setViewCustomer(itemCopy);
    } else if (location?.state == null) {
      navigate("/dashboard");
    }
  }, [location?.state, designationdata, documentList]);

  useEffect(() => {
    if (salesEngineerData) {
      setSalesEngineer(salesEngineerData);
    }
  }, [salesEngineerData]);

  useEffect(() => {
    if (customertype) {
      setCustomerTypeData(customertype);
    }
  }, [customertype]);

  const getSalesEngineerName = (id) => {
    const salesEng = salesEngineer.find((item) => item?.identityId === id);
    if (salesEng) {
      return `${salesEng?.firstName} ${salesEng?.lastName}`;
    }
    return "";
  };

  const getCustomerTypeName = (ids) => {
    if (customerTypeData) {
      const customerTypeNames = [];
      if (typeof ids === "string") {
        const idArray = ids.split(",");
        idArray.forEach((id) => {
          const type = customerTypeData.find(
            (item) => item.id === parseInt(id, 10)
          );
          if (type) {
            customerTypeNames.push(type.type);
          }
        });
      } else if (typeof ids === "number") {
        const type = customerTypeData.find((item) => item.id === ids);
        if (type) {
          customerTypeNames.push(type.type);
        }
      }
      return customerTypeNames.join(", ");
    }
    return "";
  };

  return (
    <div className="container-fluid view-customer-sec">
      <section className="customer-view-sec mt-2">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <div class="d-flex justify-content-start align-items-center w-100 flex-wrap">
                  <Link to="/customer-master">
                    <button className="btn p-0 mr-2" type="button">
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </Link>
                  <h1>General</h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Customer Name</h5>
                      <h6>{viewCustomer?.customerName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Country</h5>
                      <h6>{viewCustomer?.countryName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Website</h5>
                      <h6>{viewCustomer?.website}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Fax Number</h5>
                      <h6>{viewCustomer?.fax}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Phone Number</h5>
                      <h6>{viewCustomer?.phone}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Email Address</h5>
                      <h6>{viewCustomer?.email}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Customer Type</h5>
                      <h6> {getCustomerTypeName(viewCustomer?.type)}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Address</h5>
                      <h6>{viewCustomer?.address}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Distributor</h5>
                      <h6>{viewCustomer?.distributorName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Sales Engineer</h5>
                      <h6>
                        {getSalesEngineerName(viewCustomer?.assignedEngineerId)}
                      </h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Status</h5>
                      <h6>{viewCustomer?.status}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <h5>Additional Info</h5>
                      <h6>{viewCustomer?.additionalInfo}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-2">
              <div className="card-header pl-3">
                <h1>Documents</h1>
              </div>
              <div className="card-body">
                <div className="row">
                  {viewCustomer?.customerDocument?.length > 0 ? (
                    viewCustomer?.customerDocument?.map((item) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 mb-4">
                        <div className="uploaded-documents">
                          <i class="far fa-file-pdf"></i>
                          <a href={item?.docuUrl} target="_blank">
                            <p>{item?.docuUrl}</p>
                          </a>
                        </div>
                      </div>
                    ))
                  ) : (
                      <div className="col-12">
                        <p className="m-0">No files</p>
                      </div>
                  )}
                </div>
              </div>
            </div>
            <div className="card mb-2">
              <div className="card-header pl-3 d-none">
                <h1>Credit Limit Approval</h1>
              </div>
              <div className="card-body d-none">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Requested Additional Open Credit</h5>
                      <h6>25000</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Available LC Credit</h5>
                      <h6>0</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div className="mt-4">
                      <h6 style={{ color: "#60EB8A" }}>
                        Credit approval is in process
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header pl-3">
                <h1>Contacts</h1>
              </div>
              <div className="card-body">
                <div className="row mt-2 contact-view-area">
                  {viewCustomer?.customerContact?.length > 0 ? (
                    viewCustomer?.customerContact?.map((item) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                        <div className="view-contact">
                          <i className="far fa-user-circle"></i>
                          <h5>{item?.name}</h5>
                          <span>{item?.email}</span>
                          <p>{item?.designationName}</p>
                          <p>{item?.phone}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 no-contact">
                      <p>No contacts avilable</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/customer-master">
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewCustomer;
